package org.multiplatform.kotfolio.pages.androidstudio

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/androidstudio/gradle")
@Composable
fun GradleAndroidStudioPage() {
    BlogLayout(
        PageProperties(
            "Gradle",
            "Gradle is a build automation tool. Its job is to take your source code and turn it into a final output — an APK for Android, a JAR for a library, or an executable for a backend service." ),
        BlogProperties("Android Studio", "Gradle")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "SDK Version",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "minSdk - the oldest Android version your app runs on.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "targetSdk - the Android version your app is tested and built for.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "compileSdk - the Android version your code is compiled with.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Gradle",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Gradle is a build automation tool. Its job is to take your source code and turn it into a final output — an APK for Android, a JAR for a library, or an executable for a backend service.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Gradle is the manager of your build process. It decides what tasks to run, in what order, and with what inputs and outputs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A task graph engine",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A dependency resolver",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A plugin-driven DSL",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Gradle Phase",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Init phase: Modules discovered. Determines which projects (modules) will participate in the build and sets up the build environment.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Configuration phase: Evaluates the build files of every project participating in the build. Creates a task graph for requested tasks. Configures all the projects and their tasks, and builds a directed acyclic graph (DAG) of the tasks to be run.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Execution phase: Purpose: Schedules and executes the selected tasks. Runs the specific tasks requested by the user or the IDE (e.g., when you click the \"Run\" button in Android Studio, it triggers a chain of AGP tasks). Gradle uses the task execution graphs generated by the configuration phase to determine which tasks to execute. Gradle can execute tasks in parallel.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Gradle settings file",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The settings.gradle.kts file (for the Kotlin DSL) or settings.gradle file (for the Groovy DSL) is located in the root project directory.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This settings file defines project-level repository settings and informs Gradle which modules it should include when building your app.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There are two main sections inside it:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )

                    Ol {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Plugin management: Dependencies are all those third party libraries that we can use in our Kotlin code when developing our apps.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Dependency resolution management: Plugins provide all the tasks (functions) that Gradle is using when building our projects. So it is basically a third party library for our gradle files.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            KotlinCode(
                code = """
                    pluginManagement {

                        /**
                          * The pluginManagement.repositories block configures the
                          * repositories Gradle uses to search or download the Gradle plugins and
                          * their transitive dependencies. Gradle pre-configures support for remote
                          * repositories such as JCenter, Maven Central, and Ivy. You can also use
                          * local repositories or define your own remote repositories. Here we
                          * define the Gradle Plugin Portal, Google's Maven repository,
                          * and the Maven Central Repository as the repositories Gradle should use to look for its
                          * dependencies.
                          */

                        repositories {
                            gradlePluginPortal()
                            google()
                            mavenCentral()
                        }
                    }
                    dependencyResolutionManagement {

                        /**
                          * The dependencyResolutionManagement.repositories
                          * block is where you configure the repositories and dependencies used by
                          * all modules in your project, such as libraries that you are using to
                          * create your application. However, you should configure module-specific
                          * dependencies in each module-level build.gradle file. For new projects,
                          * Android Studio includes Google's Maven repository and the Maven Central
                          * Repository by default, but it does not configure any dependencies (unless
                          * you select a template that requires some).
                          */

                      repositoriesMode.set(RepositoriesMode.FAIL_ON_PROJECT_REPOS)
                      repositories {
                          google()
                          mavenCentral()
                      }
                    }
                    rootProject.name = "My Application"
                    include(":app")
                    """.trimIndent()
            )

            SpanText(
                text = "build.gradle (project root)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The project-level build.gradle file is used to define global configuration and settings for the entire project. It is also used to implement dependencies and plugins on top level. By default, all configurations and settings inside our project-level build.gradle should be inherited by all the modules in the project, and build.gradle files inside modules are able to override them.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Gradle Plugin",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Gradle Plugin is a piece of code that extends Gradle’s capabilities. It registers new tasks, adds new configuration options, and wires up the build lifecycle for a specific use case.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Gradle Plugin is an extension that teaches Gradle how to build a specific type of project. Without plugins, Gradle is a blank slate. With the Android plugin, it knows how to build APKs.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    plugins {
                        id("com.android.application")
                        id("org.jetbrains.kotlin.android")
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Gradle Compiler Plugin",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Gradle Compiler Plugin is a different beast. It does not operate at the build level. It operates inside the compiler itself.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Gradle Compiler Plugin hooks into the Kotlin or Java compiler and runs during compilation, with access to the syntax tree of your code. It can inspect, transform, or generate code at the IR (Intermediate Representation) level.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    your .kt file
                         │
                         ▼
                    frontend parse          ← tokens → AST → type check
                         │
                         ▼
                    IR generation           ← AST → IR tree (typed, lowered)
                         │         ▲
                         │         │
                         │    Compiler Plugin hooks in here
                         │    reads and transforms the IR tree
                         ▼
                    backend codegen         ← IR → .class (bytecode output)
                         │
                         ▼
                      .class file
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    ┌──────────────────────────────────────────────────────────────┐
                    │  Gradle                                                      │
                    │  orchestrates the build — tasks, dependencies, caching       │
                    │                                                              │
                    │  ┌────────────────────────────────────────────────────────┐  │
                    │  │  Gradle Plugin                                         │  │
                    │  │  registers tasks — codegen, lint, APK packaging        │  │
                    │  │                                                        │  │
                    │  │  ┌──────────────────────────────────────────────────┐  │  │
                    │  │  │  Gradle Compiler Plugin                          │  │  │
                    │  │  │  runs inside the Kotlin compiler                 │  │  │
                    │  │  │  reads the IR tree, rewrites functions,          │  │  │
                    │  │  │  generates code before bytecode is produced      │  │  │
                    │  │  └──────────────────────────────────────────────────┘  │  │
                    │  └────────────────────────────────────────────────────────┘  │
                    └──────────────────────────────────────────────────────────────┘
                    """.trimIndent()
            )

            SpanText(
                text = "Gradle Catalog sections",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[versions]",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Here you specify the versions of libraries and plugins. Instead of writing the copy directly everywhere, you write it once here, and link it to the second section. This makes it easier for you and makes you controller more.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[libraries]",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Here you specify the libraries you will use in the project, such as Retrofit, Coroutines, or any other library. Links the versions you specified in [versions] to this library.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[plugins]",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Here you decide which plugins you use, such as Kotlin plugin or any other plugins. The same idea links the version to this component.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "How do we make libs.versions.toml file?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Here we degrade all the libraries we use, specifying their versions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Third, we link these versions to the build.gradle file.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Instead of directly degrading dependencies, you'll use libraries from the Gradle Catalog.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "maven Authentication",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    dependencyResolutionManagement {
                        repositoriesMode.set(RepositoriesMode.FAIL_ON_PROJECT_REPOS)

                        repositories {
                            google()
                            mavenCentral()
                            maven { url = uri("https://jitpack.io") }
                            maven {
                                url = rootDir.toURI().resolve("app/libs")
                            }

                            maven {
                                url = uri("https://api.mapbox.com/downloads/v2/releases/maven")
                                authentication {
                                    create<BasicAuthentication>("basic")
                                }
                                credentials {
                                    username = "mapbox"
                                    password = ""
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "gradle.properties",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    # Adjust -Xmx based on your M1 Mac's RAM (e.g., -Xmx4g for 8GB, -Xmx6g for 16GB)
                    org.gradle.jvmargs=-Xmx4g -Dfile.encoding=UTF-8 -XX:+HeapDumpOnOutOfMemoryError
                    kotlin.native.jvmArgs=-Xmx6g -XX:+HeapDumpOnOutOfMemoryError #Increase heap for Kotlin/Native compiler (konanc runs on JVM); default is small (~3g)

                    # Kotlin daemon heap (JVM/analysis tasks)
                    kotlin.daemon.jvmargs=-Xmx2g -XX:MaxMetaspaceSize=512m
                    kotlin.daemon.jvmargs=-Xmx3072M
                    kotlin.daemon.jvmargs=-Xmx4G
                    
                    org.gradle.daemon=true
                    
                    # Essential for Multi-module projects and works great on M1
                    org.gradle.parallel=true
                    org.gradle.workers.max=4

                    # Kotlin KSP (if you use it)
                    ksp.incremental=true
                    
                    # Smaller binary size for release binaries - Kotlin/Native (iOS)
                    kotlin.native.binary.smallBinary=true
                    kotlin.incremental.native=true
                    
                    # Runs the diagnostic only for metadata compilations and imports
                    kotlin.kmp.eagerUnresolvedDependenciesDiagnostic=false
                    #Disables the diagnostic completely
                    kotlin.kmp.unresolvedDependenciesDiagnostic=false
                    
                    # Support for stack canaries in binaries
                    kotlin.native.binary.stackProtector=yes
                    kotlin.native.binary.stackProtector=strong
                    kotlin.native.binary.stackProtector=all
                    
                    # --- Kotlin & Android ---
                    # Enables namespacing of each library's R class so that its R class includes only the
                    # resources declared in the library itself and none from the library's dependencies,
                    # thereby reducing the size of the R class for that library
                    kotlin.code.style=official                     # Use official Kotlin code style
                    android.useAndroidX=true                       # Use AndroidX instead of legacy support libs
                    android.nonTransitiveRClass=true               # Build faster by avoiding transitive R class generation
                    android.nonFinalResIds=true
                    android.enableJetifier=true
                    android.defaults.buildfeatures.buildconfig=true

                    # --- Kotlin Multiplatform (KMP) ---
                    kotlin.mpp.enableCInteropCommonization=true     # Share native interop code between targets
                    kotlin.mpp.androidGradlePluginCompatibility.nowarn=true  # Hide Android Gradle Plugin warnings
                    kotlin.mpp.enableIntransitiveMetadataConfiguration=true   # Skip unused dependency metadata
                    org.jetbrains.compose.experimental.uikit.enabled=true     # Enable Compose for iOS (UIKit)

                    # --- Kotlin/Native Optimizations ---
                    kotlin.native.cacheKind=static                 # Use static caches for faster rebuilds
                    kotlin.native.cacheKind.iosArm64=static        # Cache for iOS devices (ARM64)
                    kotlin.native.cacheKind.iosSimulatorArm64=static # Cache for iOS Simulator (Apple Silicon)
                    kotlin.native.cacheKind.iosX64=static          # Cache for iOS Simulator (Intel)
                    kotlin.incremental.native=true                 # Rebuild only changed native code
                    kotlin.native.disableCompilerDaemon=false      # Keep compiler running between builds
                    kotlin.native.useEmbeddableCompilerJar=true    # Use embedded compiler for stability
                    kotlin.native.linkerOptions=-dead_strip        # Remove unused code from binaries
                    kotlin.native.cocoapods.generate.wrapper=true  # Auto-generate CocoaPods wrapper scripts
                    kotlin.native.binary.stripDebugSymbols=false   # Keep debug symbols (set true for release)

                    # --- Gradle Performance ---
                    org.gradle.jvmargs=-Xmx6g -XX:MaxMetaspaceSize=1g -XX:+HeapDumpOnOutOfMemoryError  # Give Gradle 6GB RAM, dump on OOM
                    org.gradle.jvmargs=-Xmx4096M -Dfile.encoding=UTF-8
                    org.gradle.jvmargs=-Xmx8g -XX:MaxMetaspaceSize=1g -XX:+HeapDumpOnOutOfMemoryError
                    org.gradle.jvmargs=-Xmx6144m -XX:MaxMetaspaceSize=1024m -Dfile.encoding=UTF-8
                    
                    org.gradle.caching=true                        # Reuse previous build outputs
                    org.gradle.daemon=true                         # Keep Gradle running between builds
                    org.gradle.parallel=true                       # Build independent modules in parallel
                    org.gradle.configureondemand=true              # Configure only needed modules
                    org.gradle.configuration-cache=true
                    org.gradle.vfs.watch=true
                    
                    # Development
                    development=true
                     
                    # Native
                    kotlin.native.binary.gc=cms
                    
                    # Compose Multiplatform
                    compose.resources.always.generate.accessors=true
                    org.jetbrains.compose.experimental.wasm.enabled=true
                    # fallback for old browsers
                    org.jetbrains.compose.experimental.jscanvas.enabled=true
                    
                    # JVM 17 Error Solution (JVM-target compatibility detected)
                    kotlin.jvm.target.validation.mode = IGNORE
                    
                    android.uniquePackageNames=false
                    android.dependency.useConstraints=true
                    android.r8.strictFullModeForKeepRules=false
                    
                    android.builtInKotlin=true
                    android.newDsl=true
                    android.generateSyncIssueWhenLibraryConstraintsAreEnabled=false
                    """.trimIndent()
            )
        }
    }
}

//includeBuild(":build-logic") Vs include("build-logic").
//https://vikashgupta625.medium.com/understanding-gradle-gradle-plugin-and-gradle-compiler-plugin-7308fa253fea

